import { types, getParent, flow } from 'mobx-state-tree';
import { ShippingModeRow } from './models';
import { resolvePaginationStore } from '../PaginationStore';

const ShippingModesStore = types
  .model('ShippingModesStore', {
    shippingModes: types.array(ShippingModeRow),
    pagination: types.optional(
      resolvePaginationStore({
        onChangePerPage: (self) => getParent(self).loadShippingModes(),
        onChangePage: (self, page) => getParent(self).loadShippingModes({ page }),
      }),
      {
        perPage: 50
      },
    ),
  })
  .volatile(self => ({
    loading: false,
  }))
  .views(self => ({
    get root() {
      return getParent(self);
    },
  }))
  .actions(self => ({
    loadShippingModes: flow(function* ({ page = 1 } = {}) {
      try {
        self.loading = true;
        const response = yield self.root.api.shippingMode.index({ page: page, per_page: self.pagination.perPage });
        self.shippingModes = response.data.data;
        self.pagination.setFromMeta(response.data.meta);
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.loading = false;
    }),
    destroy: flow(function* (id) {
      let response;
      if (window.confirm('Are you sure to delete it?')) {
        try {
          self.loading = true;
          response = yield self.root.api.shippingMode.destroy(id);
          self.loadShippingModes();
        } catch (error) {
          self.root.ui.toast.error(error);
        }
        self.loading = false;
      }
    }),
  }))


export default ShippingModesStore;
